import { L } from '@lang';
import { ReactComponent as LogoIcon } from '../../shared/assets/logo.svg';
import { InstallPage, Placeholder, Button } from '../../shared/ui';
import { envs } from '../../core';
import styles from './PwaDisabledIos.module.css';

export function PwaDisabledIos() {
  return (
    <InstallPage className={styles.root}>
      <Placeholder
        icon={<LogoIcon />}
        title={L.t('pwa_disabled_ios_placeholder_title')}
        action={
          <Button onClick={() => window.open(envs.APP_STORE_URL, '', 'noopener,noreferrer')} stretched>
            {L.t('pwa_disabled_ios_placeholder_action')}
          </Button>
        }
        stretched
      />
    </InstallPage>
  );
}
